import addError from '../../../utils/error.jsx';

export function request(sportId) {
    return {
        type: 'LADDER_GET_REQUEST',
        sportId
    };
}

export function error(sportId, errors) {
    addError(errors);

    return {
        type: 'LADDER_GET_ERROR',
        errors,
        sportId
    };
}

export function finish(sportId, {prices}) {
    return {
        type: 'LADDER_GET_FINISH',
        prices,
        sportId
    };
}
